import SimpleCardHorizontal from "./SimpleCardHorizontal";

export default SimpleCardHorizontal;
